export default "<input class=\"form-control\" type=\"file\" (change)=\"changeListener($event)\" placeholder=\"Enter Icon\">\n"